(($, Drupal) => {
  const footerFunction = function () {
    let highestTitle = 0;
    const titleSpan = $('.footer-menu .footer-list__title');
    titleSpan.each(function () {
      if ($(this).height() > highestTitle) {
        highestTitle = $(this).height();
      }
    });
    titleSpan.height(highestTitle);
  };
  footerFunction();

  $(window).resize(footerFunction());
})(jQuery, Drupal);
